import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

import { addComment } from '../../../redux/actions/postActions';

import Spinner from '../../Spinner/Spinner';
import classes from './Comment.module.css';

const CommentForm = (props) => {
  const auth = useSelector(state => state.auth);
  const posts = useSelector(state => state.posts);
  const dispatch = useDispatch();
  const [addingComment, setAddingComment] = useState(false);
  const [quillValue, setQuillValue] = useState('')

  useEffect(() => {
    if (!posts.working) {
      setAddingComment(false)
      // TODO: Maybe check posts.error???
      // TODO: Do we need to invoke this or
      //    will setting posts in the action/reducer do it?
      //  props.updated(post)
    }
  }, [addingComment, posts.working]);
 
  const hasContent = (htmlString) => {
    const strippedString = htmlString.replace(/<[^>]+>/g, '');

    // Trim any leading or trailing whitespace from the stripped string
    const trimmedString = strippedString.trim();

    // Check if the trimmed string has a length greater than 0
    return trimmedString.length > 0;
  }

  const handleFormSubmit = (values) => {
    if (!hasContent(quillValue) || quillValue.trim().length < 10 || quillValue.trim().length > 1024+10) {
      values.preventDefault();
      alert(`Comment is either empty, too short, or too long.  Try again.`)
      return false;
    }
    const commentValues = {
      user_id: auth.uid,
      body: quillValue
    }
    dispatch(addComment(props.post, commentValues))
    setAddingComment(true)
  }
  
  const buildForm = () => {
    // console.log('buildForm', props)
    return (
      <div className={classes.CommentBox}>
        <h5 className={classes.CommentTitle}>
          Add A Comment
        </h5>
        <Form
          onSubmit={handleFormSubmit}
          className={classes.Form}
        >
          <ReactQuill theme="snow"
            value={quillValue} 
            onChange={setQuillValue}
            name='body'
            id='body'
            required
            modules={{
              toolbar: [
                // [{'size': [false, 'large', 'huge']}],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                ['bold', 'italic', 'underline']
              ]
            }}
          />
          <Form.Control type="hidden" id="user_id" name="user_id" value={auth.uid} />
          <div className={classes.CommentSubmit}>
            <Button type="submit">Post Comment</Button>
          </div>
        </Form>
      </div>
    );
  }

  if (addingComment) {
    return <Spinner />
  } else {
    return buildForm();
  }

}

export default CommentForm;